"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIntersectionObserver = void 0;
var react_1 = require("react");
var powerhooks_1 = require("powerhooks");
function useIntersectionObserver(params, dependencyList) {
    var callback = params.callback, rest = __rest(params, ["callback"]);
    var ref = (0, powerhooks_1.useStateRef)(null);
    var observer = (0, react_1.useMemo)(function () {
        return new IntersectionObserver(function (entries) {
            callback({
                "entry": entries[0],
                observer: observer,
            });
        }, __assign({}, rest));
    }, dependencyList);
    (0, react_1.useEffect)(function () {
        if (!ref.current) {
            return;
        }
        observer.observe(ref.current);
    }, dependencyList);
    return { ref: ref };
}
exports.useIntersectionObserver = useIntersectionObserver;
//# sourceMappingURL=useIntersectionObserver.js.map